// https://stackoverflow.com/questions/5573096/detecting-webp-support#27232658
// maybe doesn't work for firefox (65) ?
export default e => document.createElement('canvas').toDataURL('image/webp').indexOf('data:image/webp') === 0
